import ApiService from '../../utils/fetch';

const orderUrl = `${process.env.REACT_APP_BASE_URL}demand/orders/`; 

export const fetchOrderHeaderData = async (orderNumber) => {
  const response = await ApiService.get(`${orderUrl}${orderNumber}/header`);
  return response.data;
};

export const fetchOrderLinesData = async (orderNumber) => {
  const response = await ApiService.get(`${orderUrl}${orderNumber}/lineOrders`);
  return response.data.lines || response.data.items || response.data; 
};

export const fetchOrderDeliveryData = async (orderNumber) => {
  const response = await ApiService.get(`${orderUrl}${orderNumber}/delivery`);
  return response.data.deliveries || response.data.details || response.data; 
};

export const fetchOrderShipmentData = async (orderNumber) => {
  const response = await ApiService.get(`${orderUrl}${orderNumber}/shipment`);
  return response.data.shipments || response.data.details || response.data; 
};